.emailRow {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 24px;
}

.inlineJaneLogo {
  display: inline-block;
  padding: 0;
}
